import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'suka-popover-action-list',
  template: `
    <ng-content></ng-content>
  `,
})
export class PopoverActionList {
  @HostBinding('class.popover__action-list') baseClass = true;
}
